import { productUrlPrefix } from './url-utils';

export const membershipUrl = ({
  product = 'waybetter',
  path = 'membership',
  offerId,
  gameId,
  gameType,
} = {}) => {
  let basePath = `${productUrlPrefix(product)}/${path}`;

  const params = new URLSearchParams();

  offerId && params.append('offerId', offerId);
  gameId && params.append('gameId', gameId);
  gameType && params.append('gameType', gameType);

  return `${basePath}?${params.toString()}`;
};

// the url used by the quiz
export const membershipSignupUrl = (params) =>
  membershipUrl({ ...params, path: 'membership-signup' });
